/**
 * Ideal siqib chiqarish reaktori (PFR) — UnitModel.
 *
 * OGOHLANTIRISH KODLARI (i18n):
 *   reactor.noFlow       critical  F = 0
 *   reactor.hotSpot      warning   profil bo'ylab T > Tmax (params: T, Tmax, V)
 *   reactor.noReaction   info      konversiya ≈ 0
 */
import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import { resolveReaction } from '../reaction';
import type { ReactionSpec } from '../reaction';

const NORMALIZED = new WeakMap<object, PfrParams>();
function norm(p: PfrParams): PfrParams {
  const hit = NORMALIZED.get(p);
  if (hit) return hit;
  const r = { ...p, reaction: resolveReaction(p.reaction as unknown as ReactionSpec) };
  NORMALIZED.set(p, r);
  return r;
}
import type { PfrInputs, PfrOutputs, PfrParams, PfrState, PfrStepOutputs } from './types';

export const pfr: UnitModel<PfrParams, PfrInputs, PfrState, PfrStepOutputs, PfrOutputs> = {
  id: 'pfr',
  resolveParams: norm,
  init: (p, i) => initState(norm(p), i),
  step: (p, s, i, dt) => stepDynamic(norm(p), s, i, dt),
  steady: (p, i) => solveSteady(norm(p), i),
};

export * from './types';
export {
  solveSteady,
  validatePfrParams,
  validatePfrInputs,
  wallCoefficient,
  DEFAULT_PROFILE_POINTS,
  DEFAULT_STEPS,
} from './steady';
export { initState, stepDynamic } from './dynamic';
